module.exports = "<br>\n<div class=\"row\" id=\"feuille\">\n  <canvas #canvas id=\"canvas\" class=\"col\"></canvas>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/drawing-section/drawing-section.component.html
// module id = ./src/app/components/drawing-section/drawing-section.component.html
// module chunks = main